<app-modal #mailerSubscriptionsModal title="{{'site_mailer_subscriptions.modal_title' | translate}}" size="lg" [hasConfirmButton]="false" [hasCloseButton]="false">

	<div class="form-group mb-4">
		<label class="font-weight-bold mb-1 d-block">
			{{ 'site_mailer_subscriptions.select_user' | translate }}
		</label>

		<ng-select
			[items]="users"
			bindLabel="fullName"
			bindValue="id"
			[clearable]="false"
			[searchable]="true"
			placeholder="{{'site_mailer_subscriptions.select_user' | translate}}"
			[(ngModel)]="selectedUserId"
			(change)="onUserChange()">
		</ng-select>
	</div>

	<div class="text-center text-muted py-4" *ngIf="!selectedUserId">
		{{'site_mailer_subscriptions.select_user_hint' | translate}}
	</div>

	<ng-container *ngIf="selectedUserId">
		<div class="mailer-subscription-family border rounded p-3 mb-3" *ngFor="let family of reportRows">
			<div
				class="mailer-subscription-row row align-items-center"
				*ngFor="let report of family.reports; let last = last"
				[class.mb-0]="last"
				[class.mb-3]="!last">
				<div class="col-5 col-md-5">{{report.labelKey | translate}}</div>
				<div class="col-7 col-md-7">
					<ng-select
						[items]="periodItems"
						bindLabel="labelKey"
						bindValue="value"
						[multiple]="true"
						[clearable]="false"
						placeholder="{{'site_mailer_subscriptions.select_period' | translate}}"
						[ngModel]="report.periods"
						(ngModelChange)="onPeriodsChange(report, $event)">
						<ng-template ng-label-tmp ng-option-tmp let-item="item">
							{{item.labelKey | translate}}
						</ng-template>
					</ng-select>
				</div>
			</div>
		</div>
	</ng-container>

	<div class="modal-footer">
		<button class="btn btn-default mr-2" (click)="cancel()">{{'g.cancel' | translate}}</button>
		<button class="btn btn-primary" [disabled]="!selectedUserId || saving" (click)="submit()">
			<span *ngIf="saving" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
			{{'g.submit' | translate}}
		</button>
	</div>
</app-modal>
